module.exports = __webpack_public_path__ + "img/topFeature3.132fc5f.png";